import script from "./KemaskiniPemilikDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./KemaskiniPemilikDialog.vue?vue&type=script&setup=true&lang=js"

import "./KemaskiniPemilikDialog.vue?vue&type=style&index=0&id=3210883d&lang=css"

const __exports__ = script;

export default __exports__